var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.139,
    height: 34.734,
    viewBox: "0 0 122.139 34.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#069;}.b{fill:#333;}.c{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M474.251,31.256a3.465,3.465,0,0,1-3.459,3.477h-27.4a3.465,3.465,0,0,1-3.459-3.471V3.471A3.465,3.465,0,0,1,443.389,0h27.4a3.465,3.465,0,0,1,3.459,3.471Z",
    transform: "translate(-352.111)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,35.08H4.617V51.666H12.76v3.889H0Z",
    transform: "translate(0 -28.077)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76.423,33.3a2.3,2.3,0,0,1-2.487,2.308A2.31,2.31,0,1,1,76.423,33.3ZM71.658,52.289V37.434h4.617V52.289Z",
    transform: "translate(-57.259 -24.812)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M108.62,66.678c0-1.852-.06-3.394-.12-4.739h4.008l.214,2.066h.092a5.323,5.323,0,0,1,4.591-2.4c3.036,0,5.316,2.036,5.316,6.41V76.8H118.1V68.557c0-1.914-.669-3.22-2.34-3.22a2.535,2.535,0,0,0-2.369,1.731,3.328,3.328,0,0,0-.152,1.156v8.566H108.62Z",
    transform: "translate(-86.841 -49.311)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M198.177,42.571h.062a19.454,19.454,0,0,1,1.064-1.8l3.006-4.467h5.559l-5.316,6.023,6.076,8.839h-5.681l-3.615-6.106-1.156,1.459v4.647H193.56V29.6h4.617Z",
    transform: "translate(-154.922 -23.691)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M269.3,70.794c.122,1.914,2.036,2.827,4.192,2.827a12.241,12.241,0,0,0,4.1-.639l.6,3.13a14.064,14.064,0,0,1-5.376.94c-5.044,0-7.931-2.914-7.931-7.564,0-3.767,2.34-7.929,7.5-7.929,4.8,0,6.623,3.737,6.623,7.412a11.047,11.047,0,0,1-.151,1.82Zm5.438-3.158c0-1.124-.485-3.008-2.613-3.008-1.944,0-2.733,1.8-2.855,3.008Z",
    transform: "translate(-212.013 -49.271)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M355.8,29.6V46.733c0,1.671.062,3.433.122,4.436H351.81l-.182-2.156h-.09a5.194,5.194,0,0,1-4.649,2.491c-3.523,0-6.35-3.008-6.35-7.625-.03-5.012,3.1-7.929,6.653-7.929a4.561,4.561,0,0,1,3.919,1.671h.062V29.6Zm-4.625,13a4.094,4.094,0,0,0-.062-.852,2.776,2.776,0,0,0-2.7-2.248c-2.126,0-3.194,1.884-3.194,4.224,0,2.521,1.246,4.1,3.16,4.1a2.735,2.735,0,0,0,2.7-2.218,5.908,5.908,0,0,0,.092-1.062Z",
    transform: "translate(-272.561 -23.691)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M476.267,33.3a2.3,2.3,0,0,1-2.491,2.308,2.311,2.311,0,1,1,2.491-2.308ZM471.5,52.289V37.434h4.611V52.289Z",
    transform: "translate(-377.283 -24.812)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M508.46,66.678c0-1.852-.06-3.394-.12-4.739h4.008l.214,2.066h.1a5.323,5.323,0,0,1,4.591-2.4c3.036,0,5.316,2.036,5.316,6.41V76.8H517.94V68.557c0-1.914-.669-3.22-2.34-3.22a2.533,2.533,0,0,0-2.37,1.731,3.325,3.325,0,0,0-.154,1.156v8.566H508.46Z",
    transform: "translate(-406.865 -49.311)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b9852920bfe90ba3f7998d0ab1f45fe2.svg";
export { ForwardRef as ReactComponent };